import { MatDialog } from '@angular/material/dialog';
import { OnInit, Component, OnDestroy, Input } from '@angular/core';
import { Validators, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStreamChange } from '../../models/$error.model';
import { AuthService } from '../../services/auth.service';
import { take} from "rxjs/operators";
import { ForgotPasswordDialogComponent } from 'src/app/components/dialog.forgotPassword.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReCaptchaV3Service } from 'ng-recaptcha';
/**
 * Created by greg on 15/07/2018.
 */

@Component({
    selector: 'login-component',
    template: `
<div class="authenticate">
    <h1>{{reauthenticate ? 'Please reauthenticate' : 'Sign in'}}</h1>
    <div (click)="auth.googleLogin()"  class="google_btn">
        <div class="round_bg"><img src="../../assets/icons/google-icon.svg"/></div>
        Sign in with Google
    </div>
    <div class="divider">or</div>
    <form #loginForm="ngForm">
        <mat-form-field class="general">
            <input matInput  type="email" name="email" [(ngModel)]="email" placeholder="Email" required/>
            <mat-error>Please enter a valid email address</mat-error>
        </mat-form-field>
        <mat-form-field class="general">
            <input matInput type="password" name="password" [(ngModel)]="password" placeholder="Password" required>
            <mat-error>A password is required</mat-error>
        </mat-form-field>
        <div class="forgot">@if(!auth.password_email_reset_loading){<a (click)="forgotPassword()">Forgot password</a>}</div>
        <div class="control">
            <button  matButton="filled" color="primary" (click)="signin(loginForm)" [disabled]="auth.signing_in">
                @if(auth.signing_in){<mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>}
              Sign in
            </button>
        </div>
        @if(error_message){
            <div class="error_message" [textContent]="error_message"></div>
        }
    </form>

</div>
`,
    styleUrls: [`./login.page.scss`],
    imports: [MatFormFieldModule, MatButtonModule, MatProgressSpinnerModule, ReactiveFormsModule, FormsModule, MatProgressSpinnerModule, MatInputModule],
    standalone: true
})
export class LoginComponent implements OnInit, OnDestroy {

    @Input() reauthenticate = false;
    @Input() email = '';
    public error_message = '';
    private login_subscription
    password = '';

    public login_controls = new UntypedFormGroup({
        password: new UntypedFormControl('', [ Validators.required, Validators.minLength(6) ]),
        email: new UntypedFormControl('', [ Validators.required, Validators.email ])
    });

    constructor( public auth: AuthService, private dialog: MatDialog) {
        this.login_subscription = this.auth.$errors.subscribe((error: ErrorStreamChange) => {
            // console.log('error ', error);
            switch (error.code) {
                case 'auth/user-not-found':
                    this.error_message = 'Sorry, we don\'t have a user that matches the details you provided.';
                    break;
                case 'auth/wrong-password':
                    this.error_message = 'Sorry, the password you provided doesn\'t match our records.';
                    break;
                case 'auth/too-many-requests':
                    this.error_message = 'Too many unsuccessful login attempts';
                    break;
                default:
                    this.error_message = error.data['message'];
                    break;
            }
        });
    }
    ngOnInit() {}
    async signin(form) {
        if(this.reauthenticate){
            await this.auth.signOut();
        }
        if (form.invalid) return;
        this.error_message = '';
        this.auth.signing_in = true;
        this.auth.signInWithEmailAndPassword(this.email, this.password);
    }

    forgotPassword() {
        this.auth.password_email_reset_loading = true;
        const d = this.dialog.open(ForgotPasswordDialogComponent, {width: '480px'});
        d.afterClosed().pipe(take(1)).subscribe(result => {
            this.auth.password_email_reset_loading = false;
        });
    }

    ngOnDestroy() {
        this.login_subscription.unsubscribe();
    }
}
